<template>
	<div class="charts" id="pie">

	</div>

</template>

<script>
  import { queryDriverTotal } from  "@/api/driver/driverinfo"
	export default {
		name: "charts",
		props: {
			title: {
				type: String,
				default: () => (
					''
				)
			},
		},
		data() {
			return {
				pieData: [], //
				colorArr: ["#FFD7D2", "#77E5E8", "#D46ACF", "#AB87F2", "#0FEF9C", "#E44D73", "#9825FD", "#FD5400", "#FEE62A",
					"#118EFA", "#0FEF9C", "#E44D73", "#9825FD", "#FD5400", "#FEE62A", "#118EFA", "#0FEF9C", "#E44D73", "#9825FD",
					"#FD5400", "#FEE62A", "#118EFA", "#0FEF9C", "#E44D73", "#9825FD"
				],
				pieSize: ["45%", "70%"],
				pieValue: ["正式", "待审核", "未通过",], //
			}
		},
		created() {
			queryDriverTotal().then(res => {
				if(res.data.code==0){
          let datas = res.data.data;
          this.$nextTick(() => {
            this.drawpie("pie", datas, this.pieValue, this.colorArr, this.pieSize, '#333');
          });
        }
			})

		},
		methods: {
			drawpie(dom, data, value, color, size, textColor) {
				let myChart = this.$echarts.init(document.getElementById(dom));
				const option = {
					color: color,
					tooltip: {
						trigger: "item",
						formatter: "{a} <br/>{b}: {c} ({d}%)"
					},
					legend: {
						orient: 'vertical',
						x: "left",
						y: "center",
						left: "30",
						itemGap: 20,
						data: value,
						itemWidth: 12,
						itemHeight: 14,
						textStyle: {
							color: textColor,
							fontSize: 14,
							height: 17,
							lineHeight: 17,
							rich: {
								a: {
									width: 60,
								},
								b: {
									width: 20,
									align: 'right'
								},
							},
						},

						formatter: function(name) {
							let index = 0;
							var datas = option.series[0].data;
							datas.forEach(function(v, i) {
								if (v.name == name) {
									index = i;
								}
							})
							return [`{a| ${name}}`, `{b| ${datas[index].value} }`].join('');
						}
					},
					series: [{
						name: "司机数量",
						type: "pie",
						radius: size,
						center: ['70%', '50%'],
						avoidLabelOverlap: false,
						label: {
							normal: {
								show: false,
								position: "center"
							},
						},
						labelLine: {
							normal: {
								show: false
							}
						},
						data: data
					}]
				};
				myChart.setOption(option);
			}
		}
	};
</script>

<style scoped>
	.charts {
		background: #fff;
		width: 100%;
		height: 250px;
		box-shadow: 0px 2px 4px 0px rgba(187, 187, 187, 0.25);
		border-radius: 4px;
	}
</style>
